import {FaIcon, PageHeader} from 'client/js/util/layout_utils';
import {Link} from 'react-router-dom';
import { useEffect, useState } from 'react';
import ConfirmedDelete from 'client/js/util/confirmed_delete';
import HandleDetails from './handle';
import {useQuery} from '@tanstack/react-query';
import LoadingTableSpinner from 'client/js/util/loading_table_spinner';
import {errorToComponent} from 'client/js/util/rest_utils';
import IcannVerificationButton from './icann_verification_button';

const fetchData = async (id) => {
  const response = await $.ajax({ url: `/usercp/handles/${id}`, dataType: 'json' });

  return response;
}

const IcannValidationBanner = ({ handle, refetch }) => {
  const [isVerified, setIsVerified] = useState(handle.icann_verified);

  useEffect(() => {
    setIsVerified(handle.icann_verified);
  }, [handle.id, handle.icann_verified]);

  useEffect(() => {
    if (handle.icann_verified) {
      setIsVerified(true);
    }
  }, [handle.icann_verified]);

  if (!handle.needs_icann_verification) {
    return null;
  }

  if (isVerified) {
    return (
      <div className="alert alert-success">
        <strong>ICANN-Verifizierung erfolgreich</strong>
        {' '}
        Der Domaininhaberkontakt ist verifiziert. Falls Du Domains mit diesem Kontakt besitzt, die noch auf &quot;ICANN Suspended&quot; oder &quot;ICANN Unverified&quot; stehen, kann es bis zu einer Stunde dauern, bis die Domain als validiert markiert wird.
      </div>
    );
  }

  return (
    <div className="alert alert-warning">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <strong>ICANN-Verifizierung erforderlich</strong>
          {' '}
          Dieser Domaininhaberkontakt ist nicht verifiziert. Für Domains mit diesem Kontakt kann eine Verifizierung erforderlich sein. Starte die Verifizierung, um den Token per E-Mail anzufordern oder direkt einzugeben.
        </div>
        <IcannVerificationButton
          handleId={handle.id}
          handleEmail={handle.email}
          onVerified={() => {
            setIsVerified(true);
            refetch?.();
          }}
        />
      </div>
    </div>
  );
}

const Page = (props) => {
  const { data, isLoading, isError, error, refetch } = useQuery(['handle', props.match.params.id], () => fetchData(props.match.params.id));

  if(isLoading) {
    return <>
      <PageHeader text="Adresse anzeigen" back_url="/handles" />

      <LoadingTableSpinner />
    </>
  }

  if(isError) {
    return errorToComponent(error);
  }

  const handle = data.handle;

  const buttons = <>
    <Link to={`/handles/${handle.id}/edit`} className="btn btn-light"><FaIcon name="pencil" /> bearbeiten</Link>

    <ConfirmedDelete id={handle.id} disabled={!handle.deletable} resource="handles" button_text={<><FaIcon name="trash" /> löschen</>}
      button_class="btn btn-danger" text="Dies wird die Adresse löschen. Sollten gesetzliche Aufbewahrungspflichten bestehen wird die Adresse als gelöscht markiert und nach Ablauf der Aufbewahrungspflichten gelöscht."
      success_cb={() => { props.history.push('/handles') }} />
  </>;

  return <>
    <PageHeader text="Adresse anzeigen" back_url="/handles" buttons={buttons}>
      Adresse anzeigen
    </PageHeader>

    <IcannValidationBanner handle={handle} refetch={refetch} />

    <div className="row">
      <div className="col-md-6">
          <HandleDetails handle={handle} />
      </div>
    </div>
  </>;
}

export default Page;
